/**
 * The ONLY hand-written hooks the vendored v2 report gets for the public demo.
 * Everything else under `application-detail-v2` is a byte-for-byte copy of
 * pre-prod (see scripts/vendor-report-v2.mjs), which applies the two tiny
 * patches that consult this module.
 *
 * Demo fixtures carry `propertyId === DEMO_PROPERTY_ID`, so the vendored
 * components' own navigation (`/properties/demo/applications/:id/v2` and
 * `/v2/combined`) lands on the redirect routes in `app/routes/properties.demo.*`
 * which map back to `/demo-report?variant=…`.
 */
export const DEMO_PROPERTY_ID = 'demo'

/** Fake, no-auth credit-report PDF for the demo. */
export const DEMO_CREDIT_PREVIEW_SRC = '/resources/demo-credit-report?demo=1'

/**
 * Credit-report preview URL override. The live dialog streams the applicant's
 * real report blob; the demo property has none, so it points at the fake PDF.
 * Must carry a `?query` — the dialog appends `&disposition=inline`.
 */
export function demoCreditPreviewSrc(propertyId: string): string | null {
	return propertyId === DEMO_PROPERTY_ID ? DEMO_CREDIT_PREVIEW_SRC : null
}

/**
 * The credit-report preview is gated on the download permission in the live
 * app; the public demo has no permissions at all (no viewer), so the demo
 * property opens the preview regardless. The ID, income, and rent modals also
 * show their download controls for visual parity despite `can.download` being
 * false in every public fixture.
 */
export function isDemoProperty(propertyId: string | null | undefined): boolean {
	return propertyId === DEMO_PROPERTY_ID
}

/**
 * Attached combined-report.html omits Individual Flags. Only that household
 * (not other demo combined reports, and not the individual guarantor page).
 */
export function demoHidesIndividualFlags(
	groupId: string | null | undefined,
): boolean {
	return groupId === 'demo-group-haddad'
}
